<app-modal title="Registro de Localização" styleClass="h-fit w-[800px]" [isOpen]="isOpen()" (closed)="onCloseModal()">
  @if(isDelete()){
  <p class="mt-2 mb-8">Você tem certeza que deseja deletar este registro?</p>
  <div class="flex justify-end mt-4">
    <p-button label="Cancelar" type="button" class="mr-2" [disabled]="isLoading()" (click)="onCloseModal()" />
    <p-button label="Deletar" type="button" icon="pi pi-trash" styleClass="p-button-danger" (click)="deleteLocation()"
      [disabled]="isLoading()" />
  </div>

  }
  @else { @if (coords()) {
  <div class="h-[250px] w-full mb-8">
    <app-world-map [initialCoord]="coords()" [isDraggable]="false" [isScrollable]="false" [zoomRange]="[12, 18]"
      styleClass="rounded-lg border-1 border-gray-300" />
  </div>
  }
  <app-location-form [initialData]="location()" [enabled]="false" [isLoading]="false" />
  }
</app-modal>